import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Stack } from "@mui/material";
import botPhotoPlaceholder from "../../images/bot-avatar.png";
export const CreateBotAvatar = ({ children, avatar }) => {
    const currentAvatar = typeof avatar === 'string' ? avatar : botPhotoPlaceholder;
    return (_jsxs(Stack, Object.assign({ alignItems: 'center', rowGap: 5, mb: 1.5 }, { children: [_jsx(Avatar, Object.assign({ src: currentAvatar, alt: 'Bot-Avatar', sx: { width: 212, height: 212 } }, { children: 'B' })), children] })));
};
